import React, { useState } from 'react';
import { configService } from '../services/configService';

function FeatureEngagementModal({ 
  isOpen, 
  onClose, 
  featureType, 
  featureId, 
  featureName, 
  context = {} 
}) {
  const [loading, setLoading] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  if (!isOpen) return null;

  const handleResponse = async (response) => {
    setLoading(true);
    
    try {
      await configService.recordFeatureEngagement(
        featureType,
        featureId,
        featureName,
        response,
        context
      );
      
      setShowThankYou(true);
      setTimeout(() => {
        setShowThankYou(false);
        onClose();
      }, 2000);
      
    } catch (error) {
      console.error('Failed to record engagement:', error);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  if (showThankYou) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-8 rounded-2xl max-w-md w-full mx-4 shadow-xl text-center">
          <h2 className="text-2xl font-bold text-blue-600 mb-4">Thank You!</h2>
          <p className="text-gray-600">Your feedback helps us prioritize features that matter most to you.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-2xl max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Feature Coming Soon</h2>
        <p className="text-gray-600 mb-6">
          <strong>{featureName}</strong> is currently in development. 
          Would you like to be notified when it becomes available?
        </p>
        
        <div className="flex gap-3">
          <button 
            className="flex-1 px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-semibold transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
            onClick={() => handleResponse('interested')}
            disabled={loading}
          >
            {loading ? 'Recording...' : 'Yes, Notify Me'}
          </button>
          <button 
            className="flex-1 px-6 py-3 bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 rounded-xl font-semibold transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
            onClick={() => handleResponse('declined')}
            disabled={loading}
          >
            {loading ? 'Recording...' : 'Not Interested'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FeatureEngagementModal;